// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1KxyY","content":"LoadingAlert_content__2meVM"};